import React, { useState, useEffect,useContext } from 'react';
import LGOLogo from '../../../assets/SVG/LGO.svg';
import { useNavigate } from 'react-router-dom';
import { AccountContext } from '../../../Contexts/main.context';

const CreateLGOAccount = () => {
    const context = useContext(AccountContext);
    const { updateClientAccounts,updateActiveClient} = context || {};
    const [showModal, setShowModal] = useState(false);
    const navigate = useNavigate();
    const [form, setForm] = useState({
        companyName: '',
        address: '',
        city: '',
        postalCode: '',
        phone: '',
        script : 'AddNewLGOAccount',
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        setShowModal(true);
    }, []);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleCancel = () => {
        setShowModal(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            const response = await fetch("https://www.lgfantasy.ca/Citations/PHP/data.php", {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(form),
            });

            const data = await response.json();
            updateClientAccounts(data);
            setShowModal(false);
            // if (typeof updateClientAccounts === 'function') updateClientAccounts([]);
            // if (typeof updateActiveClient === 'function') updateActiveClient('-');
        } catch (err) {
            setError(err.message || 'Error saving client. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    if (!showModal) return null;

    return (
        <div
            className="modal show d-flex align-items-center justify-content-center"
            tabIndex="-1"
            style={{
                background: 'rgba(0,0,0,0.5)',
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 1050,
            }}
        >
            <div className="modal-dialog modal-dialog-centered w-50" style={{ margin: '0 auto' }}>
                <div className="modal-content">
                    <form onSubmit={handleSubmit}>
                        <div className="modal-header flex-column align-items-center bg-navy">
                            <img
                                src={LGOLogo}
                                alt="LGO Logo"
                                style={{ width: 180, height: 45 }}
                            />
                            <h5 className="modal-title w-100 text-center text-white mt-2">Create LGO Account</h5>
                            <h5 className=" w-100 text-center text-lemon fs-7 text-uppercase">(All Fields are required)</h5>
                        </div>
                        <div className="modal-body">
                            {[
                                { name: 'companyName', label: 'Company Name' },
                                { name: 'address', label: 'Address' },
                                { name: 'city', label: 'City' },
                                { name: 'postalCode', label: 'Postal Code' },
                                { name: 'phone', label: 'Phone' },
                            ].map(({ name, label }) => (
                                <div className="mb-3" key={name}>
                                    <label className="form-label">{label}</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name={name}
                                        value={form[name]}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                            ))}

                            {error && <div className="alert alert-danger">{error}</div>}
                        </div>
                        <div className="modal-footer justify-content-between">
                            <button type="button" className="btn btn-danger" onClick={handleCancel} disabled={loading}>
                                Cancel
                            </button>
                            <button type="submit" className="btn btn-success text-white w-25" disabled={loading}>
                                {loading ? 'Saving...' : 'Save'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default CreateLGOAccount;
